export default "__VITE_ASSET__DCz2dzS6__"